<template>
    <div class="view-home">
        <div class="block-company">
            <div v-if="urlBackToPortal" class="back-to-portal">
                <a :href="urlBackToPortal"> < Retour au portail</a>
            </div>
            <div class="block-company-content">
                <div class="block-company-gradient"></div>
                <div class="block-company-text">
                    <div v-if="userSite">
                        <h1>{{ userSite.facility }}</h1>
                        <h2>{{ userSite.company }}</h2>
                    </div>
                    <div v-else>
                        <h1>Sélection du site</h1>
                        Veuillez choisir le site auquel vous voulez vous connecter
                    </div>
                </div>
            </div>
        </div>
        <div class="home-layout" v-if="!userSite">
            <el-row>
                <el-col
                    :xs="24"
                    :sm="24"
                >
                    <el-button
                        v-if="userIsAtLeastManager"
                        style="font-size: 20px;"
                        type="primary"
                        class="btn-edit"
                        icon="el-icon-plus"
                        @click="createSite"
                    >
                        Créer un nouveau site
                    </el-button>
                    <br>
                    <br>
                    <br>
                </el-col>

                <div v-if="site.length===0">
                    <h3>Vous n'avez aucun site</h3>
                </div>

                <div v-if="site.length > 0">
                    <br>
                    Sélectionnez un site
                    <el-input
                        v-model="search"
                        placeholder="Rechercher"
                        class="input-search"
                    ></el-input>
                    <div class="sites-list">
                        <el-card
                            v-for="(_site, index) in filteredSite"
                            :key="index"
                        >
                            <div
                                class="sites-list__header"
                            >
                                <p class="sites-list__header__name">
                                    {{_site.facility}}
                                </p>
                                <div class="sites-list__buttons-container">
                                    <el-button
                                        icon="el-icon-edit"
                                        circle
                                        type="info"
                                        @click="editSite(_site)"
                                    ></el-button>
                                    <el-button
                                        icon="el-icon-delete"
                                        circle
                                        type="danger"
                                        plain
                                        @click="archiveSite(_site)"
                                    ></el-button>
                                </div>
                            </div>
                            <hr>
                            <div>
                                <div class="sites-list__button-container">
                                    <el-button
                                        type="primary"
                                        @click="setSite(_site)"
                                    >
                                        SÉLECTIONNER
                                    </el-button>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
            </el-row>
        </div>
        <div v-else class="padding">
            <div class="site-tree-container">
                <el-row>
                    <el-col
                        :xs="12"
                        :sm="12"
                    >
                        <el-button
                            style="font-size: 1em;"
                            class="btn-edit"
                            type="text"
                            icon="el-icon-arrow-left"
                            @click="unsetSite"
                        >
                            Sélectionner un autre site
                        </el-button>
                    </el-col>
                    <el-col
                        :xs="12"
                        :sm="12"
                    >
                        <el-button
                            style="font-size: 1em; margin-left: auto; display: block;"
                            class="btn-edit"
                            type="text"
                            @click="archiveSite"
                        >
                            Supprimer ce site
                            <i class="el-icon-delete icon"></i>
                        </el-button>
                    </el-col>
                </el-row>
                <div class="button-wrapper">
                    <h2
                        v-if="displayActionButtons"
                        class="step-title action-title"
                        :class="dynamicClass"
                    >{{ actionButtonsProps.name }}</h2>
                    <ActionButtons
                        v-if="displayActionButtons"
                        :data="actionButtonsProps"
                        @refreshTree="refreshAllData"
                    ></ActionButtons>
                </div>
                <Synoptic
                    ref="synpotic"
                    class="synoptic-container"
                    @enableActionButtons="enableActionButtons"
                ></Synoptic>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Synoptic from '@/components/page/Synoptic/Index.vue';
import ActionButtons from '@/components/page/Synoptic/ActionButtons/Index.vue';


export default {
    name: 'Home',
    
    components: {
        Synoptic,
        ActionButtons
    },
    
    data (){
        return {
            verboseStatus: {
                'VALIDATED': 'VALIDÉ',
                'PREPARED': 'PRÉPARÉ',
                'SHIPPED': 'EXPÉDIÉ',
                'AUDITED': 'AUDITÉ',
                'RECEIVED': 'REÇU',
                'PENDING': 'EN ATTENTE',
            },
            siteForm: {
                facility: '',
                company: '',
            },
            auditForm: {
                name: '',
                motorbox_count: 0,
                date: '',
            },
            search: '',
            displayMotorForm: false,
            actionButtonsProps: null,
            displayActionButtons: false,
        };
    },
    
    computed: {
        ...mapGetters([
            'currentSite',
            'site',
            'userByUid',
            'currentUser',
            'userIsAtLeastManager',
            'motors',
            'applicationMode'
        ]),
        userSite () {
            if (this.currentSite){
                return this.currentSite;
            }
        },
        urlBackToPortal(){
            return window.config.master_page_url;
        },
        filteredSite () {
            return this.site.filter((site) => {
                return site.facility.toLowerCase().includes(this.search.toLowerCase());
            });
        },
          dynamicClass() {
            switch (this.actionButtonsProps.entity) {
                case 'workshop': return 'workshop'
                case 'zone': return 'zone'
                case 'equipment':
                    return this.actionButtonsProps.equipment_type === 'motor' ? 'motor' : 'machine'
                default: return 'secondary'
            }
        }
    },
    
    methods: {
        enableActionButtons(props) {
            this.$set(this,'actionButtonsProps', props);
            this.displayActionButtons = true;
        },
        editSite(site){
            this.$router.push({
                name: 'Site',
                params: {
                    siteUid: site.uid
                }
            });
            this.$store.commit('SET_CURRENT_SITE', site);
        },
        addNewMotor(){
            let siteUid = this.currentSite.uid;
            if(this.applicationMode === 'advanced'){
            this.$router.push({name: 'AdvancedMotorForm', params: { siteUid: siteUid }});
            }else{
                this.$router.push({name: 'AdvancedMotorForm', params: { siteUid: siteUid }});
            }
        },
        setSite(site){
            this.$store.commit('SET_CURRENT_SITE', site);
        },
        unsetSite(){
            this.$store.commit('UNSET_CURRENT_SITE');
        },
        createSite(){
            this.unsetSite();
            this.$router.push({name: 'Site'});
        },
        archiveSite(selectedSite=null){
            var site = this.userSite ? this.userSite : selectedSite;
            this.$confirm('Voulez-vous vraiment supprimer ce site ?', site.company, {
                type: 'warning',
                confirmButtonText: 'Confirmer',
                cancelButtonText: 'Annuler',
            })
            .then(() =>{
                this.$store.dispatch('patchItem', {
                    item: {
                        archived: true,
                        url: site.url,
                    },
                    model: 'site',
                    url: this.$store.state.api.meta.listModels.site.url,
                })
                .then(() => {
                    this.$store.dispatch(
                        'reloadModels',
                        {site}
                    ).then(() => {
                        this.unsetSite();
                        this.$notify({
                            title: 'Supprimé',
                            message: 'Le site a été supprimé',
                            type: 'success',
                            duration: 3000,
                        });
                    });
                })
                .catch(() => {
                    this.$notify({
                        title: 'Erreur',
                        message: 'Le site n\'a pas pu être supprimé',
                        type: 'success',
                        duration: 3000,
                    });
                });
            }).catch(() => {
                return;
            });
        },
        updateApplicationMode(mode){
            this.$store.dispatch('updateApplicationMode', mode);
        },
        refreshAllData(){
            this.$refs.synpotic.refreshData()
        }
    },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.site-tree-container, .home-layout {
    width: 100%;
    .button-wrapper{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        .action-title{
            margin-bottom: 0;
        }
        .step-title.workshop { color: $--color-workshop !important; }
        .step-title.zone { color: $--color-zone !important; }
        .step-title.motor { color: $--color-motor !important; }
        .step-title.machine { color: $--color-machine !important; }
        .step-title.secondary { color: $--color-secondary !important; }
        .buttons-container{
           display: flex;
           z-index: 1;
           .tile-button{
               
               border: none;
               color: white;
               // height: 50px;
               span{
                   .button-icon-image{
                       i{
                           .icon-img{
                               height: 12.25px;
                               display: block;
                               margin-top: 0.25rem
                           }
                           .fa-icon{
                               display: block;
                               margin-top: 0.25rem
                           }
   
                       }
                   }
   
               }
           }
            .tile-button.workshop { background-color: $--color-workshop !important; }
            .tile-button.zone { background-color: $--color-zone !important; }
            .tile-button.motor { background-color: $--color-motor !important; }
            .tile-button.machine { background-color: $--color-machine !important; }
            .tile-button.secondary { background-color: $--color-secondary !important; }
       }
    }
}
.synoptic-container{
    max-height: calc(100vh - 300px);
    overflow: auto;
}
.block-company {
    position: relative;
    background: url('../../../../static/images/img-bandeau-carto-view.jpg') no-repeat center center;
    background-size: cover;
    color: white;
    h1 {
        font-size: 40px;
        line-height: 40px;
        margin-bottom: 0;
    }
    h2 {
        font-size: 20px;
        line-height: 20px;
        text-transform: uppercase;
    }
    .block-company-text {
        display: block;
        position: relative;
        max-width: $layout-width;
        margin: auto;
        padding: 0 20px;
    }
    .block-company-content {
        display: block;
        position: relative;
        padding: 10px 0 20px;
    }
    .block-company-gradient {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(to bottom, rgba(#000,0) 0%,rgba(#000,0.3) 100%);
    }
}
.price-box {
    h3 {
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        padding: 20px 0 30px;
        .mwh-unit {
            font-size: 12px;
            vertical-align: super;
        }
    }
}

.description-list {
    margin: 0;
    dt {
        font-size: 12px;
        color: #ccc;
    }
    dd {
        margin: 0;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    a {
        color: $--color-primary !important;
    }
}

.view-home {
    .home-subnav {
        padding: 20px;
        padding-top: 0;
        .el-tooltip.el-button.el-button--text{
            padding: 0;
        }
    }
    .btn-download-motor-file{
        margin-bottom: 30px;
    }
}
.sites-list{
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    &__header{
        display: flex;
        justify-content: space-between;
        &__name{
            width: 15rem;
            color: #303133;
            font-weight: 500;
            font-size: 20px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            margin: 0;
        }
    }
    .el-card{
        width: 30rem;
        height: 22rem;
    }
    &__button-container{
        text-align: center;
        margin-top: 4rem;
        .el-button{
            width: 100%;
        }
    }
    &__buttons-container{
        .el-button{
            margin: 0;
            padding: 1rem;
        }
    }
}
.input-search {
    margin-top: 1em;
    margin-bottom: 1em;
}
.facility-name-btn {
    padding-left: 1em;
    padding-right: 1em;
    margin-bottom: 1em;
}
.icon {
    margin-left: 5px;
}
.add-motor{
    margin-top: 5rem;
    margin-left: 5rem;
}
.el-button.add-motor{
    background-color: $--color-primary !important;
    color: white;
}
.el-button.add-motor:hover{
    background-color: $--color-secondary;
    color: white;
    border-color: $--color-secondary;
}
.flex{
    display: flex;
    justify-content: center;
}
.home-layout{
    padding: 2rem 20rem;
}
.motor-cards{
    height: 55rem;
    max-height: 55rem;
    overflow-y: auto;
}
.no-motor{
    width: 45em;
    font-style: italic;
    text-align: center;
    margin-top: 2em;
    color: grey;
}
.back-to-portal{
    padding: 1rem 0 0 19rem;
    a {
        color: white;
    }
}
.legend-container{
    margin-left: 5rem;
    margin-top: 0.5rem;
    .legend{
        display: flex;
        gap: 0.5rem;
        align-items: center;
        margin-bottom: 0.5rem;
        .legend-square {
            width:20px;
            height:20px;
            border-radius: 4px;
            &.simple{
                background-color: #005BBA;
            }
            &.advanced{
                background-color: #455769;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/AutonomeHome.vue